/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ViewupSnsAccountsCounts
 */
export interface ViewupSnsAccountsCounts {
    /**
     * 카테고리
     * @type {string}
     * @memberof ViewupSnsAccountsCounts
     */
    'category': ViewupSnsAccountsCountsCategoryEnum;
    /**
     * 
     * @type {number}
     * @memberof ViewupSnsAccountsCounts
     */
    'count': number;
}

export const ViewupSnsAccountsCountsCategoryEnum = {
    Instagram: 'instagram',
    Youtube: 'youtube',
    Facebook: 'facebook',
    Nblog: 'nblog',
    Googleplay: 'googleplay',
    Appstore: 'appstore',
    Kakaochannel: 'kakaochannel',
    Naverband: 'naverband',
    Web: 'web',
    Threads: 'threads'
} as const;

export type ViewupSnsAccountsCountsCategoryEnum = typeof ViewupSnsAccountsCountsCategoryEnum[keyof typeof ViewupSnsAccountsCountsCategoryEnum];


